import { render, staticRenderFns } from "./UiSelectOption.vue?vue&type=template&id=fe9e8554"
import script from "./UiSelectOption.vue?vue&type=script&lang=js"
export * from "./UiSelectOption.vue?vue&type=script&lang=js"
import style0 from "./UiSelectOption.vue?vue&type=style&index=0&id=fe9e8554&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports